import { useCallback, useEffect, useMemo, useState } from 'react';
import { formatRangeLabel } from './formatters';
import { buildBrushDetails } from './rangeUtils';

export function useBrushSelection({ data = [], dataKey = 'date', summaryPrefix = 'Selected range' } = {}) {
  const [selection, setSelection] = useState(null);
  const [version, setVersion] = useState(0);

  const handleChange = useCallback(
    (range) => {
      const details = buildBrushDetails(range, data, dataKey);
      setSelection(details);
    },
    [data, dataKey]
  );

  const reset = useCallback(() => {
    setSelection(null);
    setVersion((prev) => prev + 1);
  }, []);

  useEffect(() => {
    if (!selection) return;
    if (!Array.isArray(data) || data.length === 0) {
      setSelection(null);
      return;
    }
    if (selection.endIndex > data.length - 1) {
      setSelection(null);
    }
  }, [data, selection]);

  const summary = useMemo(() => {
    if (!selection?.startValue || !selection?.endValue) return '';
    const rangeLabel = formatRangeLabel(selection.startValue, selection.endValue);
    if (!rangeLabel) return '';
    return `${summaryPrefix}: ${rangeLabel}`;
  }, [selection, summaryPrefix]);

  return {
    selection,
    onChange: handleChange,
    reset,
    summary,
    version
  };
}

